<template>
  <div class="testPage">
    <template v-if="from!='introDetail'">
      <div id="block"></div>
      <Header />
      <Box1 />
    </template>
    <Box4 />
    <Box3 />
    <Box2 />
    <Box5 />
    <Box6 />
    <Box7 />
    <Box9 />
    <Box10 />
    <Box11 />
    <Box8 />
    <Box13 />
    <Box14 />
    <Box15 />
    <Box16 />
    <Box17 />
    <Box18 />
    <pageRightFloat pageName="软件测试-就业课" />
    <Footer />
  </div>
</template>

<script>
import Box1 from "./Box1.vue";
import Box2 from "./Box2.vue";
import Box3 from "./Box3.vue";
import Box4 from "./Box4.vue";
import Box5 from "./Box5.vue";
import Box6 from "./Box6.vue";
import Box7 from "./Box7.vue";
import Box8 from "./Box8.vue";
import Box9 from "./Box9.vue";
import Box10 from "./Box10.vue";
import Box11 from "./Box11.vue";
import Box13 from "./Box13.vue";
import Box14 from "./Box14.vue";
import Box15 from "./box15.vue";
import Box16 from "./box16.vue";
import Box17 from "./box17.vue";
import Box18 from "./box18.vue";

import pageRightFloat from "../common/pageRightFloat.vue";
import Header from "../common/Header.vue";
import Footer from "../common/Footer.vue";

export default {
  components: {
    Box1,
    Box2,
    Box3,
    Box4,
    Box5,
    Box6,
    Box7,
    Box8,
    Box9,
    Box10,
    Box11,
    Box13,
    Box14,
    Box15,
    Box16,
    Box17,
    Box18,
    pageRightFloat,
    Header,
    Footer,
  },
   data() {
    return {
      from:''
    };
  },
  mounted() {
   this.from=this.getQueryString("from")
  },
  methods: {
    toLink() {
      window.open("https://m.boxuegu.com/");
    },
    zixun(name) {
      zhuge.track("H5_软件测试专题页", {
        咨询按钮名称: name,
      });
      this.clickZiXun()
    },
  },
};
</script>

<style lang="scss" scoped>
.testPage {
  width: 750px;

  position: relative;
  left: 0;
  right: 0;
  /* 
  overflow: hidden; */
}
#block {
  width: 100%;
  height: 88px;
}
</style>
